module.exports = __webpack_public_path__ + "img/still (31).421555c0.jpg";